<template>
    <el-button @click="$router.go(-1)" type="primary">返回</el-button>
</template>

<script>
    export default {
        name: "CommonBack"
    }
</script>

<style scoped>

</style>